import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, shareReplay } from 'rxjs';
import { Icons } from '../../models/icons.model';

@Injectable({ providedIn: 'root' })
export class SvgIconCacheService {
  private readonly httpClient = inject(HttpClient);
  private readonly cache = new Map<Icons | string, Observable<string>>();

  public get(name: Icons | string): Observable<string> {
    if (this.cache.has(name)) {
      return this.cache.get(name) as Observable<string>;
    }

    const cachedResult = this.httpClient.get(`icons/${name}.svg`, { responseType: 'text' }).pipe(shareReplay());
    this.cache.set(name, cachedResult);

    return cachedResult;
  }
}
